import {HttpClient} from '@angular/common/http';
import {Injectable, OnInit} from '@angular/core';
import {ConfigServiceProvider} from "../../../core/services/config-service/config-service";
import {StorageServiceProvider} from "../../../core/services/storage-service/storage-service";

/*
  Generated class for the KpiServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class KpiServiceProvider implements OnInit{

  constructor(public http: HttpClient, private configService: ConfigServiceProvider, private storageService: StorageServiceProvider) {
  }

  ngOnInit(){

  }

  load(){
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('kpiDefinitions'))
        .toPromise()
        .then( response =>{
          this.storageService.setObject('kpiDefinitions', response);
          resolve(response);
        })
        .catch(err => {
          console.error(err);
          reject(err);
        });
    });
  }

  getKpiDefinitions(){
    return this.storageService.getObject('kpiDefinitions');
  }


}



// WEBPACK FOOTER //
// ./src/modules/ranking/services/kpi-service/kpi-service.ts